import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      '& .MuiOutlinedInput-root': {
        width: 200,
        minWidth: 180
      }
    },
    autoCompleteWrapper:{
      width: '100%',
      '& .MuiAutocomplete-inputRoot': {
        flexWrap: 'nowrap',
        overflow: 'hidden'
      },
      '& .MuiAutocomplete-input': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      },
    }
  })
);